import { Type } from '@sinclair/typebox';
import { createClientError } from '../core/create-client-error.js';
const MatchedOn = ['invoiceNumber', 'ocr'];
export const DuplicateInvoiceError = createClientError('DUPLICATE_INVOICE_ERROR', Type.Object({
    existingId: Type.String(),
    matchedOn: Type.Union(MatchedOn.map((value) => Type.Literal(value))),
}));
